import {axiosIns} from 'config/api.config'
import {ENV} from 'config/ENV.config'

/** One leaf item in a menu group. Shaped by sso-service MenuService.node(). */
export interface IMenuItem {
  featureId: string
  code?: string
  title: string
  /** Bangla label. Null for items that have no translation yet — fall back to `title`. */
  titleBn?: string | null
  /** The route this item links to. Also the permission key — see permission.helper.tsx. */
  url: string
  /** Bootstrap Icons class, e.g. `bi-person-vcard`. Null falls back to a generic icon. */
  icon?: string | null
  sortOrder?: number
}

/** A top-level dropdown. Groups arrive already ordered and never empty. */
export interface IMenuGroup extends Omit<IMenuItem, 'url'> {
  url?: string | null
  children: IMenuItem[]
}

/**
 * The app's navigation menu, served from sso `auth.features`.
 *
 * The menu used to be hardcoded JSX in layouts/components/header/MenuInner.tsx, with
 * labels split across en.json/bn.json and ~20 literals. It now comes from the database
 * so it can be renamed and re-grouped from the SSO menu editor without a redeploy.
 *
 * Called through the SSO gateway — same arrangement as notification.service.ts and
 * favorite.service.ts — reusing axiosIns so auth headers and the 401 interceptor apply.
 * The server filters by role and drops empty groups, so whatever comes back is exactly
 * what this user should see.
 */
export const MenuService = {
  getAppMenu: async (appName: string = ENV.appCode): Promise<any> =>
    await axiosIns.get(`/menu/${appName}`, {baseURL: ENV.ssoGetway}),
}
